import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
const state = {
  Website: {
    'Id': 0,
    'PageTitle': '',
    'WebsiteURL': '',
    'SubscriptionModuleActivation_Id': 0,
    'HeaderElements': '',
    'FooterElements': ''
  }
}
const getters = {
  Website: state => state.Website
}
const mutations = {
  [mutationNames.SET_WEBSITE] (state, Parent) {
    state.Website = Parent
  },
  [mutationNames.UPDATE_WEBSITE] (state, obj) {
    Object.assign(state.Website, obj)
  }
}
const actions = {
  updateWebsiteSettings ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_WEBSITE, payload)
  },
  async getWebsiteInfo ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetWebsiteInfo(SubscriptionModuleId)
    commit(mutationNames.SET_WEBSITE, response)
    return response
  },
  async saveWebsiteSettings ({ dispatch, getters }) {
    let WebsiteClone = Object.assign({}, getters.Website)
    await api.AppModules.SaveWebsiteInfo(WebsiteClone)
  },
  async WebsiteUrlValidChk ({ commit, getters }, WebsiteUrl) {
    const response = await api.AppModules.WebsiteUrlValid(WebsiteUrl)
    return response
  },
  async captureScreen ({ commit, getters }, payload) {
    return api.screenShot.capture(payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/website.js